import { useState } from "react";
import { CloudSun } from "lucide-react";
import { useWeather } from "@/lib/weather";
import { CitySearch } from "@/components/CitySearch";

// Scelta della città del meteo nel Profilo (salvata nell'account, vale su tutti i dispositivi).
export function MeteoCityCard() {
  const { city } = useWeather();
  const [editing, setEditing] = useState(false);
  return (
    <div data-testid="meteo-city-card" className="mt-6 rounded-2xl border border-hair bg-surfaceSecondary p-5">
      <div className="flex items-center gap-2 mb-1">
        <CloudSun size={18} className="text-brand" />
        <h2 className="text-base font-semibold text-onSurface">Città del meteo</h2>
      </div>
      <p className="text-sm text-subtle mb-4">La ritrovi su tutti i dispositivi dove accedi.</p>
      <div className="flex flex-wrap items-center gap-3">
        <span data-testid="meteo-city-current" className="text-sm font-semibold text-onSurface">{city.manual ? city.name : `${city.name} (predefinita)`}</span>
        <button type="button" data-testid="meteo-city-change" onClick={() => setEditing((v) => !v)}
          className="px-3.5 py-2 rounded-full text-xs font-semibold border border-hair bg-surface text-onSurfaceSecondary hover:border-brand/50 hover:text-brand transition-colors">
          {editing ? "Annulla" : "Cambia città"}
        </button>
      </div>
      {editing && <div className="mt-4"><CitySearch onDone={() => setEditing(false)} /></div>}
    </div>
  );
}
